import { createLucideIcon } from 'lucide-react';

const LayersIcon = createLucideIcon('LayersIcon', [
  [
    'path',
    {
      d: 'M12.225 2.3081C12.4216 2.22468 12.6445 2.22906 12.8377 2.32012L22.0735 6.6736C22.6471 6.94399 22.6471 7.76004 22.0735 8.03043L12.8377 12.3839C12.6445 12.475 12.4216 12.4794 12.225 12.3959L1.96296 8.04246C1.35349 7.78391 1.35349 6.92013 1.96296 6.66159L12.225 2.3081',
      key: 'path-1',
      stroke: 'currentColor',
      strokeWidth: '2',
      fill: 'none',
    },
  ],
  [
    'path',
    {
      d: 'M1.96296 17.4572L5.77551 15.8399L5.1897 14.4589L1.37715 16.0762C0.758736 16.3469 0.758738 17.4433 1.37715 17.714L11.6392 22.0674C12.2291 22.3226 12.8976 22.3095 13.4772 22.0363L22.713 17.6829C23.2866 17.4217 23.2866 16.6057 22.713 16.344L19.2308 14.7209L18.5912 16.3277L22.0735 17.9692C22.6471 18.2396 22.6471 19.0556 22.0735 19.326L12.8377 23.6795C12.6445 23.7705 12.4216 23.7749 12.225 23.6915L1.96296 19.338C1.35349 19.0795 1.35349 18.2157 1.96296 17.4572Z',
      key: 'path-2',
      stroke: 'currentColor',
      strokeWidth: '2',
      fill: 'none',
    },
  ],
]);

export default LayersIcon;
